import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { movedItems } from "../data/navigation";
const topics = [{
  key: "brand",
  label: "Brand & trust",
  count: 6,
  className: "bg-i9-blue"
}, {
  key: "sports",
  label: "Sports",
  count: 9,
  className: "bg-i9-red"
}, {
  key: "age",
  label: "Age groups",
  count: 4,
  className: "bg-i9-royal"
}, {
  key: "help",
  label: "FAQ & search",
  count: 2,
  className: "bg-i9-sky"
}];
function LinkBar({
  counts
}: {
  counts: Record<string, number>;
}) {
  return <div className="flex flex-wrap gap-1" aria-hidden="true" data-id="element-50" data-mp="2huz9bpjomyv4">
      {topics.flatMap(t => Array.from({
      length: counts[t.key] ?? 0
    }).map((_, i) => <span key={`${t.key}-${i}`} className={`h-5 w-4 ${t.className}`} data-id="element-51" data-mp="233i2jccmjm0z" data-mpi={i} />))}
    </div>;
}
export function IAComparison() {
  return <div className="flex flex-col gap-10" data-id="element-52" data-mp="1u4d74ewd08t1">
      <section aria-labelledby="scope-heading" data-id="element-53" data-mp="1u5ojh33veovr">
        <h3 id="scope-heading" className="font-display text-2xl font-extrabold uppercase text-i9-navy" data-id="element-54" data-mp="1z4hnm4x9p3j9">
          One topic instead of four
        </h3>
        <p className="mt-1 max-w-xl text-i9-ink/70" data-id="element-55" data-mp="37yylsco8tzia">
          The current menu spreads 21 links and a search box across four unrelated topics. The proposed menu holds only
          the brand story — six links.
        </p>

        <div className="mt-6 grid gap-6 sm:grid-cols-[140px_1fr] sm:items-center" data-id="element-56" data-mp="3czuxvdir0rys">
          <div data-id="element-57" data-mp="3cxrwjxc5bcer">
            <p className="text-sm font-semibold uppercase tracking-wide text-i9-ink/60" data-id="element-58" data-mp="2paa37xd8g69o">Current</p>
            <p className="font-display text-xl font-bold text-i9-navy" data-id="element-59" data-mp="2kb79va6m7ohj">About Us · 21</p>
          </div>
          <LinkBar counts={{
          brand: 6,
          sports: 9,
          age: 4,
          help: 2
        }} data-id="element-60" data-mp="2z03fz1p42rfi" />
          <div data-id="element-61" data-mp="2z26d05oolktq">
            <p className="text-sm font-semibold uppercase tracking-wide text-i9-ink/60" data-id="element-62" data-mp="2z1wj470imtir">Proposed</p>
            <p className="font-display text-xl font-bold text-i9-navy" data-id="element-63" data-mp="26jsoiwp8jb7b">Why i9 Sports · 6</p>
          </div>
          <LinkBar counts={{
          brand: 6
        }} data-id="element-64" data-mp="21kpl1gowld1g" />
        </div>

        <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-sm text-i9-ink/70" data-id="element-65" data-mp="21k68yglxpivc">
          {topics.map(t => <li key={t.key} className="flex items-center gap-2" data-id="element-66" data-mp="5fgoxgw2ltq3">
              <span className={`h-3 w-3 ${t.className}`} aria-hidden="true" data-id="element-67" data-mp="afcu3jgi7r78" />
              {t.label}
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="moved-heading" data-id="element-68" data-mp="j8pwdc0gk55z">
        <h3 id="moved-heading" className="font-display text-2xl font-extrabold uppercase text-i9-navy" data-id="element-69" data-mp="j8g41hrxxlx4">
          Where the rest goes
        </h3>
        <table className="mt-4 w-full text-left" data-id="element-70" data-mp="3nn62d3gr4p9s">
          <thead data-id="element-71" data-mp="3nnpokwdfpztm">
            <tr className="border-b-2 border-i9-navy text-xs uppercase tracking-wide text-i9-ink/60" data-id="element-72" data-mp="3npa71nmh5sb4">
              <th scope="col" className="py-2 pr-4 font-semibold" data-id="element-73" data-mp="3rqvu21sq3mz1">Leaving About Us</th>
              <th scope="col" className="py-2 font-semibold" data-id="element-74" data-mp="jrmn5so1yq3">New home</th>
            </tr>
          </thead>
          <tbody data-id="element-75" data-mp="170mvq3mq14q7">
            {movedItems.map(m => <tr key={m.item} className="border-b border-i9-line align-top" data-id="element-76" data-mp="1bwlpy7uqdgyj">
                <td className="py-3.5 pr-4" data-id="element-77" data-mp="1m23gh4lbdijj">
                  <p className="font-semibold text-i9-navy" data-id="element-78" data-mp="1m126l3g1b23e">{m.item}</p>
                  <p className="text-sm text-i9-ink/60" data-id="element-79" data-mp="1h3if31ubssti">{m.detail}</p>
                </td>
                <td className="py-3.5" data-id="element-80" data-mp="1caz2a73gq1pr">
                  <p className="flex items-center gap-2 font-semibold text-i9-blue" data-id="element-81" data-mp="1c9xr82mg5f81">
                    <ArrowRightIcon className="h-4 w-4 shrink-0" data-id="element-82" data-mp="189nl8pynmot6" />
                    {m.destination}
                  </p>
                  <p className="pl-6 text-sm text-i9-ink/60" data-id="element-83" data-mp="138zkvdojcvma">{m.path}</p>
                </td>
              </tr>)}
          </tbody>
        </table>
        <p className="mt-4 text-sm text-i9-ink/70" data-id="element-84" data-mp="tdxvcgqclrj6">
          “About i9 Sports®” is renamed <span className="font-semibold text-i9-navy" data-id="element-85" data-mp="pbt1phzwguwj">Our Mission</span> and becomes the
          lead feature of the new menu.
        </p>
      </section>
    </div>;
}